module.exports = __webpack_public_path__ + "static/media/delete.23badd66.svg";